import moveFiles from '../Services/moveFile';

export default () => (dispatch) => {
  
  dispatch(moveFiles());

}